var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgAddInstitutionIcon = function SvgAddInstitutionIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2655_8459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9023 23.6812C22.1115 23.6812 23.9023 21.8903 23.9023 19.6812C23.9023 17.472 22.1115 15.6812 19.9023 15.6812C17.6932 15.6812 15.9023 17.472 15.9023 19.6812C15.9023 21.8903 17.6932 23.6812 19.9023 23.6812Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9023 17.6812V21.6812",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9023 19.6812H21.9023",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9023 13.681V9.18103C18.9021 9.1004 18.8823 9.02102 18.8448 8.94967C18.8072 8.87832 18.7529 8.81711 18.6866 8.77127C18.6203 8.72543 18.5438 8.69632 18.4638 8.68641C18.3838 8.6765 18.3025 8.68609 18.227 8.71437L12.727 11.561C12.6319 11.5966 12.5499 11.6604 12.4919 11.7437C12.4339 11.8271 12.4027 11.9261 12.4023 12.0277V14.681",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4023 11.6812H18.9023",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4023 13.6812H18.9023",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90234 16.6812H10.4023",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90234 18.6812H11.4023",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9023 10.9519V8.68188",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9023 23.6812V15.6812C13.9023 15.4159 13.797 15.1616 13.6095 14.974C13.4219 14.7865 13.1676 14.6812 12.9023 14.6812H9.90234C9.63713 14.6812 9.38277 14.7865 9.19524 14.974C9.0077 15.1616 8.90234 15.4159 8.90234 15.6812V23.6812H14.9023",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2655_8459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.40234 8.18115)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgAddInstitutionIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";